import urlTool from '@/tools/url';
import fetchJQueryAdapter from '@/tools/fetchJQueryAdapter';

/**
 * @memberof module:ajaxAPI/compare
 * @alias add
 *
 * @description
 * Добавление товара в сравнение
 *
 * @param {number} id - id товара, добавляемого в сравнение
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.compare.add(123456)
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function(id) {
  const lang = urlTool.getKeyValue('lang') || '';
  const fields = {
    lang: lang,
    product: { id: parseInt(id) }
  };

  return fetchJQueryAdapter('/front_api/compares.json',
    {
      method: 'POST',
      body: JSON.stringify(fields),
      headers: { 'Content-Type': 'application/json' }
    }
  );
}
